import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2daaf17a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-controls" }
const _hoisted_2 = { class: "video-control-section justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "control-button-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "telehealth-icon icon-flip" }, null, -1))
const _hoisted_5 = { class: "control-button-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-tele-camera-flip telehealth-icon" }, null, -1))
const _hoisted_7 = { class: "control-button-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-tele-hangup telehealth-icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-tele-call telehealth-icon" }, null, -1))
const _hoisted_10 = { class: "control-button-container" }
const _hoisted_11 = { class: "control-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoundButton = _resolveComponent("RoundButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showViewCycle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_RoundButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cycleView'))),
              title: "Switch between fit and fill video modes",
              "button-style": _ctx.ButtonColorPattern.TRANSPARENT
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["button-style"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_RoundButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('flip'))),
          "button-style": _ctx.ButtonColorPattern.TRANSPARENT,
          disabled: _ctx.state.disabled
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["button-style", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.state.canEnd)
          ? (_openBlock(), _createBlock(_component_RoundButton, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hangup())),
              disabled: _ctx.callButtonDisabled || _ctx.state.disabled,
              "button-style": _ctx.ButtonColorPattern.FILL,
              color: _ctx.ButtonColor.DANGER
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled", "button-style", "color"]))
          : (_openBlock(), _createBlock(_component_RoundButton, {
              key: 1,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.call())),
              disabled: _ctx.callButtonDisabled || _ctx.state.disabled,
              "button-style": _ctx.ButtonColorPattern.FILL,
              color: _ctx.ButtonColor.SUCCESS
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled", "button-style", "color"]))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_RoundButton, {
          disabled: _ctx.state.disabled,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('mute'))),
          active: _ctx.state.muted,
          "button-style": _ctx.ButtonColorPattern.TRANSPARENT
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass([_ctx.muteStateClass, "telehealth-icon"])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["disabled", "active", "button-style"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_RoundButton, {
          disabled: _ctx.state.disabled || this.toggleVideoButtonDisabled,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleVideo())),
          active: !_ctx.state.videoEnabled,
          title: "Toggle video",
          "button-style": _ctx.ButtonColorPattern.TRANSPARENT
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["telehealth-icon", _ctx.videoStateClass])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["disabled", "active", "button-style"])
      ])
    ])
  ]))
}